<script>
import { debounce } from 'lodash'

export default {
  data() {
    return {
      showPageTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleDisplayPageTopButton)
  },
  methods: {
    handleDisplayPageTopButton: debounce(function (e) {
      const scrollY = window.scrollY
      if (scrollY > 500) {
        this.showPageTop = true
      } else {
        this.showPageTop = false
      }
    }, 400),
    scrollToPageTop: debounce((e) => {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    })
  }
}
</script>
<template>
  <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
  >
    <a
        v-if="showPageTop"
        class="ml-auto block h-14 w-14"
        @click="scrollToPageTop">
      <img src="https://cdn.restir.com/common/re_top.png" width="35" height="35" alt="to-top" class="w-full">
    </a>
  </transition>
</template>
